import { useState, useRef, useEffect } from 'react';
import { buildStudioContext, stripMarkdown } from '../utils/helpers';

const CHAT_ENDPOINT = "/api/chat";

export const useChat = () => {
  const [chatOpen, setChatOpen] = useState(false);
  const [chatMsgs, setChatMsgs] = useState([
    { role: "bot", text: "Hey! I'm the Nismay Studios assistant. Ask me anything about our services, process, past work, pricing, or open freelance roles." }
  ]);
  const [chatInput, setChatInput] = useState("");
  const [chatLoading, setChatLoading] = useState(false);
  const chatBodyRef = useRef(null);
  const chatStarted = useRef(false);

  useEffect(() => {
    if (chatBodyRef.current) {
      chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
    }
  }, [chatMsgs, chatLoading, chatOpen]);

  const sendChatMessage = async (text) => {
    const clean = text.trim();
    if (!clean || chatLoading) return;
    chatStarted.current = true;
    const nextMsgs = [...chatMsgs, { role: "user", text: clean }];
    setChatMsgs(nextMsgs);
    setChatInput("");
    setChatLoading(true);
    try {
      const res = await fetch(CHAT_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          context: buildStudioContext(),
          messages: nextMsgs.map(m => ({
            role: m.role === "user" ? "user" : "assistant",
            content: m.text,
          })),
        }),
      });
      if (!res.ok) throw new Error("Chat request failed");
      const data = await res.json();
      const replyText = stripMarkdown(data.reply) || "Sorry, I didn't catch that — try again?";
      setChatMsgs(m => [...m, { role: "bot", text: replyText }]);
    } catch (err) {
      setChatMsgs(m => [...m, { role: "bot", text: "Something went wrong reaching the assistant. Please email info@nismaystudios.in and we'll get back to you directly." }]);
    } finally {
      setChatLoading(false);
    }
  };

  const CHAT_SUGGESTIONS = [
    "What services do you offer?",
    "How does your process work?",
    "Any freelance roles open?",
    "How can I contact you?",
  ];

  return {
    chatOpen,
    setChatOpen,
    chatMsgs,
    chatInput,
    setChatInput,
    chatLoading,
    chatBodyRef,
    chatStarted,
    sendChatMessage,
    CHAT_SUGGESTIONS
  };
};